import { render } from "./applicationRouting.vue?vue&type=template&id=052ea02f&scoped=true"
import script from "./applicationRouting.vue?vue&type=script&lang=js"
export * from "./applicationRouting.vue?vue&type=script&lang=js"

import "./applicationRouting.vue?vue&type=style&index=0&id=052ea02f&lang=scss&scoped=true"
import "./applicationRouting.vue?vue&type=style&index=1&id=052ea02f&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-052ea02f"]])

export default __exports__